export default "__VITE_ASSET__85dedf60__"